module.exports = __webpack_public_path__ + "img/vistaClasica.d41640e1.png";